import { compose } from 'redux';
import { connect } from 'react-redux';
import withBaseDrawer from 'components/common/Drawers/withBaseDrawer';
import { getTemplateFile } from 'redux-core/import-tracks-spreadsheet/actions';
import { userIdSelector } from 'redux-core/auth/selectors';
import {
    getSelectedProductionIdSelector,
    getSelectedProductionDivisionIdSelector,
} from 'redux-core/overview/selectors';

const mapStateToProps = (state) => ({
    currentUserId: userIdSelector(state),
    productionId: getSelectedProductionIdSelector(state),
    divisionId: getSelectedProductionDivisionIdSelector(state),
});

const mapDispatchToProps = {
    getTemplateFile,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withBaseDrawer);
